var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "report-layout__location" },
      [
        _c(
          "div",
          {
            staticClass: "level",
            class: { "is-marginless_old": _vm.moveChartIcons },
          },
          [
            _c("div", { staticClass: "level-left" }, [
              _vm.heading
                ? _c("h3", {
                    staticClass: "title is-4 map-title",
                    domProps: { textContent: _vm._s(_vm.heading) },
                  })
                : _vm._e(),
            ]),
            _c("div", { staticClass: "level-right" }, [
              _vm.showDownload
                ? _c(
                    "a",
                    {
                      staticClass:
                        "button map-title is-small gtm-download-excel level-item",
                      attrs: { href: _vm.downloadURL, target: "_blank" },
                    },
                    [
                      _c("dc-icon", { attrs: { icon: "download" } }),
                      _c("span", [_vm._v(_vm._s(_vm.downloadLabel))]),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
        _c(
          "gmap-map",
          {
            ref: "gmap",
            staticClass: "locations-map",
            class: { "no-pins": !_vm.hasLocations },
            attrs: {
              center: _vm.center,
              zoom: 10,
              "map-type-id": "roadmap",
              options: _vm.mapOptions,
            },
          },
          _vm._l(_vm.locations, function (location) {
            return _c("gmap-marker", {
              key: location.id,
              attrs: { position: location, title: location.title },
            })
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }